import {register} from '@shopify/theme-sections';

import ResultsFilterSort from '../components/results-filter-sort';

const selectors = {
  topbar: '[data-header-topbar]',
};

export default register('collection-main', {
  onLoad() {
    ResultsFilterSort(this.container, this.id);

    // Check if we have any info stored in sessionStorage for last product clicked on collection page, and scroll to it
    if (
      window.theme?.collection?.enableScrollToClickedProduct &&
      sessionStorage.getItem('collection_clicked_product')
    ) {
      const clickedProductData = JSON.parse(sessionStorage.getItem('collection_clicked_product'));

      const currentCollection = this.container.dataset.collection;
      const storedCollection = clickedProductData.collection;

      // Check if current collection page matches the stored collection, if not reset sessionStorage
      if (!storedCollection || !currentCollection || storedCollection !== currentCollection) {
        sessionStorage.removeItem('collection_clicked_product');
        return;
      }

      const selectedProductHandle = clickedProductData.selectedProduct;
      if (!selectedProductHandle) return;

      const selectedProductCard = this.container.querySelector(`[data-product-handle="${selectedProductHandle}"]`);
      if (!selectedProductCard) return;

      // Check if product is already in view, if not scroll to it
      const bounding = selectedProductCard.getBoundingClientRect();
      const isInView = bounding.top >= 0 && bounding.bottom <= window.innerHeight;

      if (isInView) {
        // Reset sessionStorage for clicked product
        sessionStorage.removeItem('collection_clicked_product');
        return;
      }

      // Disable the default browser scroll position
      if (history.scrollRestoration) {
        history.scrollRestoration = 'manual';
      }

      let scrollPos = selectedProductCard.offsetTop - 48;

      const headerTopbar = document.querySelector(selectors.topbar);
      if (headerTopbar) {
        scrollPos = scrollPos - headerTopbar.offsetHeight;
      }

      window.scrollTo({
        top: scrollPos,
      });

      // Reset sessionStorage for clicked product
      sessionStorage.removeItem('collection_clicked_product');
    }
  },
});
